import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

/** Block A：僅狀態 */
export const bomSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {entityStatusSideMsgValue(row)}
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const bomSideMsgDetailBlock = {
  fields: [
    { label: 'BOM代號', value: 'code' },
    { label: 'BOM名稱', value: 'name' },
    { label: '版本', value: 'version' },
    { label: '備註', value: 'remark' },
  ],
};
